"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractGetPaymentDetailResponseSchema = exports.WebContractCreateOrderResponseSchema = exports.WebContractOrderIdPathParamsSchema = exports.WebContractUploadPaymentRequestSchema = exports.WebContractCreateGuestOrderRequestSchema = exports.OrderAddressRequestSchema = void 0;
const zod_1 = require("zod");
const OrderStatusSchema = zod_1.z.enum(['PENDING', 'CONFIRMED', 'SHIPPED', 'CANCELLED']);
const ShippingMethodSchema = zod_1.z.enum(['STANDARD', 'EXPRESS']);
const OrderTypeSchema = zod_1.z.enum(['GUEST', 'MEMBER']);
const OrderSchema = zod_1.z.object({
    type: OrderTypeSchema,
    status: OrderStatusSchema,
    id: zod_1.z.string().uuid(),
    userId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    expiredAt: zod_1.z.coerce.date(),
    orderNo: zod_1.z.number().int(),
    email: zod_1.z.string(),
    phone: zod_1.z.string(),
    name: zod_1.z.string(),
    discountDetails: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    memberDiscount: zod_1.z.number(),
    promotionDiscount: zod_1.z.number(),
    shippingFee: zod_1.z.number(),
    finalPrice: zod_1.z.number(),
});
const OrderAddressTypeSchema = zod_1.z.enum(['BILLING', 'SHIPPING']);
const OrderAddressSchema = zod_1.z.object({
    type: OrderAddressTypeSchema,
    id: zod_1.z.string().uuid(),
    recipientName: zod_1.z.string(),
    recipientPhoneNumber: zod_1.z.string(),
    address: zod_1.z.string(),
    address2: zod_1.z.string().nullable(),
    district: zod_1.z.string(),
    province: zod_1.z.string(),
    postalCode: zod_1.z.string(),
    orderId: zod_1.z.string(),
    countryCode: zod_1.z.string(),
});
exports.OrderAddressRequestSchema = OrderAddressSchema.omit({
    id: true,
    orderId: true,
});
exports.WebContractCreateGuestOrderRequestSchema = zod_1.z.object({
    name: zod_1.z.string().nonempty(),
    email: zod_1.z.string().email().nonempty(),
    phone: zod_1.z.string().nonempty(),
    type: zod_1.z.literal('GUEST'),
    billingAddress: exports.OrderAddressRequestSchema,
    shippingAddress: exports.OrderAddressRequestSchema,
    shippingMethod: ShippingMethodSchema,
});
exports.WebContractUploadPaymentRequestSchema = zod_1.z.object({
    imageUrl: zod_1.z.string().url().nonempty(),
    amount: zod_1.z.number().positive(),
});
exports.WebContractOrderIdPathParamsSchema = zod_1.z.object({ orderId: zod_1.z.string() });
exports.WebContractCreateOrderResponseSchema = zod_1.z.object({ order: OrderSchema.pick({ id: true }) });
exports.WebContractGetPaymentDetailResponseSchema = zod_1.z.object({
    order: OrderSchema.pick({
        id: true,
        orderNo: true,
        finalPrice: true,
    }).extend({ orderDate: zod_1.z.string() }),
});
